import { Link } from "react-router-dom";
import { useTheme } from "../data/data";
import { contactInfo } from "../data/data";
import logoLight from "../assets/logo-light.png";

export default function Footer() {
  const { theme } = useTheme();
  const W  = "rgba(255,255,255,0.7)";
  const WD = "rgba(255,255,255,0.4)";
  const WH = "#ffffff";

  return (
    <footer style={{ background: theme.footerBg, paddingTop: "4.5rem" }}>
      <div style={{ maxWidth: 1280, margin: "0 auto", padding: "0 5vw", display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1.6fr", gap: "3rem" }} className="grid-4">

        {/* Brand */}
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 16 }}>
            <img
              src={logoLight}
              alt="Kuldiip Enterprises"
              style={{ height: 64, width: "auto", display: "block", flexShrink: 0 }}
            />
            <div style={{ fontFamily: "'Playfair Display',serif", fontSize: "1.25rem", fontWeight: 700, color: WH, lineHeight: 1.15 }}>
              KULDIIP<br /><span style={{ color: theme.accent, fontSize: "0.95rem", letterSpacing: "0.08em" }}>ENTERPRISES</span>
            </div>
          </div>
          <div style={{ fontSize: "0.72rem", letterSpacing: "0.14em", textTransform: "uppercase", color: theme.accent, marginBottom: 14, fontWeight: 600 }}>
            Global Commodity & Agro Trade Partner
          </div>
          <p style={{ fontSize: "0.85rem", lineHeight: 1.8, color: W, maxWidth: 280 }}>
            Trusted supplier of industrial raw materials and agro commodities to international markets — with strategic partners in Canada and Malaysia.
          </p>
          <div style={{ display: "flex", gap: 10, marginTop: 20 }}>
            {["📞", "📧", "🌐"].map((icon, i) => (
              <div key={i} style={{ width: 36, height: 36, background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", transition: "background 0.2s", fontSize: "0.9rem" }}
                onMouseEnter={e => e.currentTarget.style.background = "rgba(255,255,255,0.16)"}
                onMouseLeave={e => e.currentTarget.style.background = "rgba(255,255,255,0.08)"}>
                {icon}
              </div>
            ))}
          </div>
        </div>

        {/* Quick links */}
        <div>
          <div style={{ fontSize: "0.7rem", letterSpacing: "0.16em", textTransform: "uppercase", color: theme.accent, marginBottom: 20, fontWeight: 700 }}>Quick Links</div>
          {[{to:"/",label:"Home"},{to:"/about",label:"About Us"},{to:"/products",label:"Products"},{to:"/quality",label:"Quality"},{to:"/contact",label:"Contact"}].map(l => (
            <Link key={l.to} to={l.to} style={{ display: "flex", alignItems: "center", gap: 6, color: W, textDecoration: "none", fontSize: "0.85rem", marginBottom: 11, transition: "color 0.2s" }}
              onMouseEnter={e => e.currentTarget.style.color = WH}
              onMouseLeave={e => e.currentTarget.style.color = W}>
              <span style={{ color: theme.accent, fontSize: "0.7rem" }}>›</span> {l.label}
            </Link>
          ))}
        </div>

        {/* Products list */}
        <div>
          <div style={{ fontSize: "0.7rem", letterSpacing: "0.16em", textTransform: "uppercase", color: theme.accent, marginBottom: 20, fontWeight: 700 }}>Products</div>
          {["Iron Ore", "Sponge Iron", "Coal", "Bauxite", "IR64 Rice", "Indian Sugar", "Spices"].map(p => (
            <div key={p} style={{ display: "flex", alignItems: "center", gap: 6, fontSize: "0.85rem", color: W, marginBottom: 11 }}>
              <span style={{ color: theme.accent, fontSize: "0.7rem" }}>›</span> {p}
            </div>
          ))}
        </div>

        {/* Contact — 2 phones, 2 addresses */}
        <div>
          <div style={{ fontSize: "0.7rem", letterSpacing: "0.16em", textTransform: "uppercase", color: theme.accent, marginBottom: 20, fontWeight: 700 }}>Contact Us</div>

          {/* Phones — hidden if array is empty */}
          {contactInfo.phones.length > 0 && (
            <div style={{ display: "flex", gap: 10, marginBottom: 18 }}>
              <span style={{ fontSize: "1rem", marginTop: 2, flexShrink: 0 }}>📞</span>
              <span style={{ fontSize: "0.84rem", color: W, lineHeight: 1.75, whiteSpace: "pre-line" }}>
                {contactInfo.phones.join("\n")}
              </span>
            </div>
          )}

          {/* Address 1 — Jodhpur (short) */}
          <div style={{ display: "flex", gap: 10, marginBottom: 14 }}>
            <span style={{ fontSize: "1rem", marginTop: 2, flexShrink: 0 }}>📍</span>
            <div style={{ fontSize: "0.84rem", color: W, lineHeight: 1.75 }}>
              <div style={{ color: theme.accent, fontSize: "0.66rem", letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 700, marginBottom: 3 }}>
                Registered Office
              </div>
              {contactInfo.addresses[0].short}
            </div>
          </div>

          {/* Address 2 — Hospet */}
          <div style={{ display: "flex", gap: 10, marginBottom: 18 }}>
            <span style={{ fontSize: "1rem", marginTop: 2, flexShrink: 0 }}>📍</span>
            <div style={{ fontSize: "0.84rem", color: W, lineHeight: 1.75 }}>
              <div style={{ color: theme.accent, fontSize: "0.66rem", letterSpacing: "0.1em", textTransform: "uppercase", fontWeight: 700, marginBottom: 3 }}>
                Branch Office
              </div>
              {contactInfo.addresses[1].full}
            </div>
          </div>

          <div style={{ display: "flex", gap: 10, marginBottom: 18 }}>
            <span style={{ fontSize: "1rem", marginTop: 2, flexShrink: 0 }}>🌐</span>
            <span style={{ fontSize: "0.84rem", color: W, lineHeight: 1.75 }}>
              Open for Global Partnerships{"\n"}& Bulk Orders
            </span>
          </div>
        </div>
      </div>

      <div style={{ maxWidth: 1280, margin: "3rem auto 0", padding: "1.4rem 5vw", borderTop: "1px solid rgba(255,255,255,0.1)", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
        <div style={{ fontSize: "0.78rem", color: WD }}>© 2025 Kuldiip Enterprises. All rights reserved.</div>
        <div style={{ fontSize: "0.78rem", color: WD }}>Jodhpur · Hospet · Open for Global Partnerships</div>
      </div>
    </footer>
  );
}
